import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import UTTouchableWithoutFeedback from '../UTTouchableWithoutFeedback';

import styles from './styles';

const UTToggle = ({ style, options, activeIndex }) => (
  <div style={[styles.container, style]}>
    {options.map((option, i) => (
      <UTTouchableWithoutFeedback
        key={option.label}
        onClick={option.onClick}
        style={i === activeIndex ? styles.activeSide : styles.inactiveSide}
      >
        {option.label.toUpperCase()}
      </UTTouchableWithoutFeedback>
    ))}
  </div>
);

UTToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      show: PropTypes.bool.isRequired
    })
  ),
  activeIndex: PropTypes.number.isRequired
};

export default Radium(UTToggle);
